import { Navigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { Loader2 } from "lucide-react"
import { useEffect, useState } from "react"

const AUTH_CHECK_TIMEOUT_MS = 8000

export default function RouteGuard({ children, roles }) {
  const { isAuthenticated, user, loading } = useSelector((s) => s.auth || {
    isAuthenticated: false,
    user: null,
    loading: true,
  })
  const [authCheckTimedOut, setAuthCheckTimedOut] = useState(false)

  useEffect(() => {
    if (!loading) {
      setAuthCheckTimedOut(false)
      return
    }

    const timeoutId = window.setTimeout(() => setAuthCheckTimedOut(true), AUTH_CHECK_TIMEOUT_MS)
    return () => window.clearTimeout(timeoutId)
  }, [loading])

  // A cached session is trusted for the initial render while the server check
  // completes. This keeps offline users in the dashboard instead of showing an
  // indefinite loader; a real 401 still clears the session in Redux.
  if (isAuthenticated && user) {
    if (roles?.length && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />
    return children
  }

  if (loading && !authCheckTimedOut) {
    return (
      <div className="min-h-screen flex items-center justify-center" role="status" aria-live="polite">
        <Loader2 className="h-6 w-6 animate-spin" aria-hidden="true" />
        <span className="sr-only">Checking authentication</span>
      </div>
    )
  }

  return <Navigate to="/" replace />
}
